module.exports = __webpack_public_path__ + "img/HR.128373de.jpg";